export function saveWorkbookForExport({ workbook, fileName, xlsx }) {
    getXlsxWriteFile(xlsx)(workbook, fileName)
}

function getXlsxWriteFile(xlsx) {
    return xlsx.writeFile || xlsx.default?.writeFile
}
